// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"cbe78bfe7df3861bfea3","883":"107aaaa9c1b1daacc797"}[chunkId] + ".js";
};